'use client'

import { useMasterData } from 'master-data/hooks/useMasterData/useMasterData'
import type { Product } from 'product/types'
import { ColorSheetButton } from 'product-card/components/shared/ProductColor/ColorSheetButton/ColorSheetButton'
import { SizeSheetButton } from 'product-card/components/shared/ProductSizes/SizeSheetButton'
import { useProductCardConsumerLayoutContext } from 'product-card/hooks/useProductCardConsumerLayoutContext'
import { useProductColors } from 'product-card/hooks/useProductColors'
import { useResponsive } from 'responsive/hooks/useResponsive/useResponsive'
import { AbTestKeys } from 'types/constants/AbTestKeys'
import { cx } from 'utils/cx'
import styles from './ProductCardActionButtons.module.scss'

interface ProductCardActionButtonsProps {
	readonly product: Product
}

export const ProductCardActionButtons = ({
	product,
}: ProductCardActionButtonsProps) => {
	const { isLessThanLarge } = useResponsive()
	const { abTestPage } = useMasterData()

	const { productColors } = useProductColors({ product })
	const { shouldRenderColorSheetButton, hasSizeSheetButton } =
		useProductCardConsumerLayoutContext()

	const shouldRenderSizes = hasSizeSheetButton && isLessThanLarge
	const shouldRenderActionButtons =
		shouldRenderSizes || shouldRenderColorSheetButton

	const isABTestEnabled =
		abTestPage?.enabled &&
		abTestPage?.FFKey === AbTestKeys.PlpNewMobileColorSelector

	if (!productColors) {
		return null
	}

	if (!shouldRenderActionButtons) {
		return null
	}

	return (
		<div
			className={cx(
				styles.productCardActionButtons,
				isABTestEnabled && styles.productCardActionButtonsMobileABTest
			)}
		>
			<ColorSheetButton productColors={productColors} />
			<SizeSheetButton product={product} />
		</div>
	)
}
